export default __webpack_public_path__ + "static/media/momentum-alert-circle.9c1f6452.svg";